import type { ContactCardContainer as TContactCardContainer } from 'server/repository/hygraph/generated/graphqlTypes';
import type { ISharedTemplateProps } from 'templates/TemplateMapper/types';
import { ContactCard } from './components/ContactCard';
import { CardWrapper, Container, Wrapper } from './styles';

export interface IContactCardContainerProps extends ISharedTemplateProps {
  templateProps: TContactCardContainer;
}

export const ContactCardContainer = ({
  templateProps: { data, id },
}: IContactCardContainerProps) => (
  <Container data-test={[`${id}-container`]}>
    {data?.length === 1 && (
      <Wrapper data-test={[`${id}-wrapper-1-card`]} $numberOfCards={data.length}>
        <CardWrapper>
          <ContactCard data-test={[`${id}-card1`]} {...data[0]} />
        </CardWrapper>
      </Wrapper>
    )}
    {data?.length === 2 && (
      <Wrapper data-test={[`${id}-wrapper-2-cards`]} $numberOfCards={data.length}>
        <CardWrapper>
          <ContactCard data-test={[`${id}-card1`]} {...data[0]} />
        </CardWrapper>
        <CardWrapper>
          <ContactCard data-test={[`${id}-card2`]} {...data[1]} />
        </CardWrapper>
      </Wrapper>
    )}
    {data && data.length > 2 && (
      <Wrapper data-test={[`${id}-wrapper-3-cards`]} $numberOfCards={data.length}>
        <CardWrapper>
          <ContactCard data-test={[`${id}-card1`]} {...data[0]} />
        </CardWrapper>
        <CardWrapper>
          <ContactCard data-test={[`${id}-card2`]} {...data[1]} />
        </CardWrapper>
        <CardWrapper>
          <ContactCard data-test={[`${id}-card3`]} {...data[2]} />
        </CardWrapper>
      </Wrapper>
    )}
  </Container>
);
